import { render, staticRenderFns } from "./OmProtectOtherRepeater.vue?vue&type=template&id=5cda46a3&scoped=true"
import script from "./OmProtectOtherRepeater.vue?vue&type=script&lang=js"
export * from "./OmProtectOtherRepeater.vue?vue&type=script&lang=js"
import style0 from "./OmProtectOtherRepeater.vue?vue&type=style&index=0&id=5cda46a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cda46a3",
  null
  
)

export default component.exports